import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Error } from '../data/error/error.model';
import { Injectable } from "@angular/core";
import { ReplaySubject } from 'rxjs';



@Injectable()
export class ErrorService {
  public isError$: Observable<any>;
  private isErrorSubject: ReplaySubject<any> = new ReplaySubject(1);
  
  constructor(
  ){
    this.isError$ = this.isErrorSubject
    .asObservable()
    .pipe(
      map(e => e )
    );
  }

  addError(label?: string, error?: Error, ){
    if(error){
      this.isErrorSubject.next(error.code);
    } else {
      this.isErrorSubject.next(label);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/core/error/error.service.ts